module.exports = __webpack_public_path__ + "img/public/SiteIcons/timerIcon.svg?9150206b";